import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import LoadingButton from '@mui/lab/LoadingButton';
import Stack from '@mui/material/Stack';
import { Heading } from './Typography';

export const ErrorView = ({
    title = 'Something unexpected happened :(',
    message,
}: {
    title?: string;
    message: string;
}) => {
    const navigate = useNavigate();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'center',
                flex: 1,
                width: '100%',
                gap: 4,
            }}
        >
            <Stack spacing={2}>
                <Heading>{title}</Heading>
                <Alert severity="error" action={null}>
                    {message}
                </Alert>
            </Stack>
            <LoadingButton
                variant="contained"
                color="primary"
                fullWidth
                size="large"
                onClick={() => navigate('/')}
            >
                Back to sign in
            </LoadingButton>
        </Box>
    );
};
